import o from "./aiModifyDialog.ce.vue2.js";
import t from "./aiModifyDialog.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const s = /* @__PURE__ */ r(o, [["styles", [t]]]);
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-modify-dialog/aiModifyDialog.ce.vue.js
// module id = 1197
// module chunks = 67